// extracted by mini-css-extract-plugin
module.exports = {"colMin":"styles_colMin__1bki4","colCheckbox":"styles_colCheckbox__2Hzgk"};